
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { languageOptions } from "@/translations";
import { useLanguage } from "@/hooks/use-language";

const LanguageSelectionDialog = () => {
  const { language, setLanguage, showLanguageDialog, setShowLanguageDialog, t } = useLanguage();
  
  const handleSelectLanguage = (value: string) => {
    setLanguage(value as any);
  };

  const handleConfirm = () => {
    setShowLanguageDialog(false);
  };

  return (
    <Dialog open={showLanguageDialog} onOpenChange={setShowLanguageDialog}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t.dialog.selectLanguage}</DialogTitle>
          <DialogDescription>
            {t.dialog.chooseLanguage}
          </DialogDescription>
        </DialogHeader>
        <div className="py-6">
          <RadioGroup value={language} onValueChange={handleSelectLanguage} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {languageOptions.map((option) => (
              <div key={option.value} className="flex items-center space-x-2">
                <RadioGroupItem value={option.value} id={option.value} />
                <Label htmlFor={option.value} className="cursor-pointer">{option.label}</Label>
              </div>
            ))}
          </RadioGroup>
        </div>
        <div className="flex justify-end">
          <Button onClick={handleConfirm}>{t.dialog.confirm}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LanguageSelectionDialog;
